import { render } from "./IconStress.vue?vue&type=template&id=0aac2e75"
import script from "./IconStress.vue?vue&type=script&lang=js"
export * from "./IconStress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__